/*
 * Редактирование кейсета - https://tanker.yandex-team.ru/project/adv-frontend-filters/keyset/filters%2FfilterWithSuggest%2FFilterSelectList.i18n.ts
 * Документация локализации - https://a.yandex-team.ru/arcadia/adv/frontend/docs/monorepo/i18n.md
 */
import { createI18n, createI18nRaw, createKeyset } from '@adv-frontend/l10n/src/i18n';
const keyset = createKeyset({
    'Выберите хотя бы одно значение, чтобы увидеть его в списке выбранных.': {
        ru: 'Выберите хотя\u00A0бы одно значение, чтобы увидеть его в\u00A0списке выбранных.',
        en: 'Select at\u00A0least one value to\u00A0see it\u00A0in\u00A0the list.',
        'en-IE': '',
        tr: 'Seçilenler listesinde görmek için en az bir değer seçin.',
        'zh-Hans': '请选择至少一个值以在列表中查看。',
    },
    'Выбрать все': {
        ru: 'Выбрать все',
        en: 'Select all',
        'en-IE': '',
        tr: 'Tümünü seç',
        'zh-Hans': '全选',
    },
    'Выбрать все ({count})': {
        ru: {
            one: 'Выбрать все ({count})',
            some: 'Выбрать все ({count})',
            many: 'Выбрать все ({count})',
            none: 'Выбрать все ({count})',
        },
        en: {
            one: 'Select all ({count})',
            some: 'Select all ({count})',
            many: 'Select all ({count})',
            none: 'Select all ({count})',
        },
        'en-IE': {
            one: '',
            some: '',
            many: '',
            none: '',
        },
        tr: {
            one: 'Tümünü ({count}) seç',
            some: 'Tümünü ({count} ) seç',
            many: 'Tümünü ({count}) seç',
            none: 'Tümünü ({count}) seç',
        },
        'zh-Hans': {
            one: '全选 ({count})',
            some: '全选 ({count})',
            many: '全选 ({count})',
            none: '全选 ({count})',
        },
    },
    'и ещё {count}': {
        ru: {
            one: 'и\u00A0ещё {count}',
            some: 'и\u00A0ещё {count}',
            many: 'и\u00A0ещё {count}',
            none: 'и\u00A0ещё {count}',
        },
        en: {
            one: 'and {count} more',
            some: 'and {count} more',
            many: 'and {count} more',
            none: 'and {count} more',
        },
        'en-IE': {
            one: 'and {count} more',
            some: 'and {count} more',
            many: 'and {count} more',
            none: 'and {count} more',
        },
        tr: {
            one: 've {count} daha',
            some: 've {count} daha',
            many: 've {count} daha',
            none: 've {count} daha',
        },
        'zh-Hans': {
            one: '还有{count}个',
            some: '还有{count}个',
            many: '还有{count}个',
            none: '还有{count}个',
        },
    },
    'Нет выбранных значений': {
        ru: 'Нет выбранных значений',
        en: 'No\u00A0values selected',
        'en-IE': '',
        tr: 'Seçilen değer yok',
        'zh-Hans': '未选择任何值',
    },
    'Ничего не найдено': {
        ru: 'Ничего не\u00A0найдено',
        en: 'Nothing found',
        'en-IE': 'Nothing found',
        tr: 'Sonuç bulunamadı',
        'zh-Hans': '未找到任何内容',
    },
    Поиск: {
        ru: 'Поиск',
        en: 'Search',
        'en-IE': 'Search',
        tr: 'Arama',
        'zh-Hans': '搜索',
    },
    'Попробовать снова': {
        ru: 'Попробовать снова',
        en: 'Try again',
        'en-IE': 'Try again',
        tr: 'Tekrar denemek',
        'zh-Hans': '再试一次',
    },
    'Произошла ошибка': {
        ru: 'Произошла ошибка',
        en: 'An\u00A0error occurred',
        'en-IE': 'An error has occurred',
        tr: 'Hata oluştu',
        'zh-Hans': '发生错误',
    },
    'Сбросить все': {
        ru: 'Сбросить все',
        en: 'Reset all',
        'en-IE': '',
        tr: 'Tümünü sıfırla',
        'zh-Hans': '全部重置',
    },
});
export const i18n = createI18n(keyset);
export const i18nRaw = createI18nRaw(keyset);
